// oxlint-disable no-console
import env from '@/env';

const LOG_ERRORS_TO_CONSOLE = false;

function hasConsoleQueryParam() {
  if (typeof window === 'undefined' || !window.location) {
    return false;
  }

  return new URLSearchParams(window.location.search).has('console');
}

export function isDebugOn() {
  return hasConsoleQueryParam() || env.NODE_ENV === 'development';
}

function info(...args) {
  if (isDebugOn()) {
    console.info(...args);
  }
}

function warn(...args) {
  if (isDebugOn()) {
    console.warn(...args);
  }
}

function error(...args) {
  if (LOG_ERRORS_TO_CONSOLE || isDebugOn()) {
    console.error(...args);
  }
}

export default {
  info,
  warn,
  error,
};
